const FilterSortIcon = ({
  style = { width: "1.8vh", height: "1.8vh" },
  color = "grey",
}) => {
  return (
    <svg viewBox="0 0 512 512" style={style} xmlns="http://www.w3.org/2000/svg">
      <path
        d="m318.49 130.223h37.6a45.941 45.941 0 0 1 86.132 0h53.778a16 16 0 0 1 0 32h-53.776a45.94 45.94 0 0 1 -86.13 0h-37.6a16 16 0 0 1 0-32zm177.51 115.433h-143.9a45.94 45.94 0 0 0 -86.131 0h-18.709a16 16 0 1 0 0 32h18.708a45.94 45.94 0 0 0 86.131 0h143.901a16 16 0 0 0 0-32zm0 115.432h-17.533a45.94 45.94 0 0 0 -86.131 0h-145.076a16 16 0 1 0 0 32h145.076a45.94 45.94 0 0 0 86.131 0h17.533a16 16 0 0 0 0-32zm-194.359-260.588a26.938 26.938 0 0 0 -21.072-43.72h-253.597a26.938 26.938 0 0 0 -21.072 43.712l7.484 9.4h280.776zm-262.917 41.221 68.416 85.928v211.576a16 16 0 0 0 24 13.857l61.261-35.37a16 16 0 0 0 8-13.856v-176.207l68.416-85.928z"
        fill={color && color}
      />
    </svg>
  );
};

export default FilterSortIcon;
